import { ReactElement } from 'react';
import { Area, ComposedChart, Line, YAxis } from 'recharts';
import {
  FLAT_LINE_VAL,
  SPARK_CHART_DATA_KEY,
  SPARK_CHART_HEIGHT,
  SPARK_CHART_WIDTH,
  SPARKCHART_LINE_WIDTH
} from '@Components/ScenarioPlanningChart/scenario-planning-chart-utils';

interface FlightingSparkChartProps {
  color: string;
  data: object[];
  useHistoricalFlighting: boolean;
  filled?: boolean;
}

export const FlightingSparkChart = ({
  color,
  data,
  useHistoricalFlighting,
  filled = false
}: FlightingSparkChartProps): ReactElement => (
  <ComposedChart data={data} height={SPARK_CHART_HEIGHT} width={SPARK_CHART_WIDTH}>
    {filled ? (
      <Area
        activeDot={false}
        dataKey={SPARK_CHART_DATA_KEY}
        dot={false}
        fill={color}
        fillOpacity={0.15}
        isAnimationActive={false}
        name={SPARK_CHART_DATA_KEY}
        stroke={color}
        strokeWidth={SPARKCHART_LINE_WIDTH}
        type='linear'
      />
    ) : (
      <Line
        activeDot={false}
        dataKey={SPARK_CHART_DATA_KEY}
        dot={false}
        fillOpacity={1}
        isAnimationActive={false}
        name={SPARK_CHART_DATA_KEY}
        stroke={color}
        strokeWidth={SPARKCHART_LINE_WIDTH}
      />
    )}
    {!useHistoricalFlighting && <YAxis hide domain={[0, 2 * FLAT_LINE_VAL]} />}
  </ComposedChart>
);
